import React from "react";

const baseStyle = {
  fontSize: 11,
  padding: "6px 12px",
  borderRadius: 9,
  background: "#ffffff",
  outline: "none",
  minWidth: 140,
};

/** Department dropdown for assessment forms (TPRM, PIA, ROPA, Gap). */
export default function DepartmentDropdown({
  value,
  onChange,
  departments = [],
  loading = false,
  disabled = false,
  required = false,
  lockToAssigned = false,
  style = {},
}) {
  const missing = !value;
  const locked = lockToAssigned && !loading && departments.length === 1;
  return (
    <select
      value={value}
      onChange={onChange}
      disabled={disabled || loading || locked}
      required={required}
      title={
        locked
          ? "Your assigned department"
          : departments.length > 1
            ? "Choose one of your assigned departments"
            : undefined
      }
      style={{
        ...baseStyle,
        border: `1px solid ${missing ? "rgba(239,68,68,0.35)" : "rgba(99,102,241,0.18)"}`,
        color: missing ? "#64748b" : "#0f172a",
        ...style,
      }}
    >
      {!locked && (
        <option value="">
          {loading ? "Loading departments..." : "Select department *"}
        </option>
      )}
      {departments.map((d) => (
        <option key={d.id} value={d.id}>
          {d.code} - {d.name} ({d.owner_name}){d.is_head ? " — Head" : ""}
        </option>
      ))}
    </select>
  );
}
